<template>
  <div v-if="template_details.rsvp_support">
    <v-row no-gutters>
      <v-col class="font-weight-bold">
        {{ $t("OTHER_DETAILS") }}
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="px-3 pb-3" outlined>
          <v-row v-if="template_details.rsvp_support">
            <v-col cols="12" md="12" class="py-0">
              <v-textarea
                :label="$t('INVITATION_FROM')"
                v-model="other_details.invitation_from"
                :rules="rules.funtionNameRule"
                rows="2"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="6" class="py-0" v-if="is_edit">
              <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="other_details.main_date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :label="$t('MAIN_DATE')"
                    required
                  ></v-text-field>
                  <!-- :rules="rules.mainRule" -->
                </template>
                <v-date-picker
                  v-model="date"
                  @change="other_details.main_date = display_date_formate(date)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6" class="py-0" v-if="is_edit">
              <v-text-field
                :label="$t('MAIN_VENUE')"
                v-model="other_details.main_venue"
              >
              </v-text-field>
              <!-- :rules="rules.mainVenue" -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="py-0"> </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="py-0" v-if="is_edit">
        <v-card class="px-3 pb-3" outlined>
          <v-text-field
            :label="$t('SPECIAL_MESSAGE')"
            v-model="other_details.special_message"
            :rules="rules.funtionNameRule"
            v-if="template_details.special_message_support"
          >
          </v-text-field>
          <v-text-field
            :label="$t('SPECIAL_MESSAGE')"
            v-model="other_details.special_message2"
            :rules="rules.funtionNameRule"
            v-if="template_details.special_message2_support"
          >
          </v-text-field>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import messages from "../../app-js/messages.js";
export default {
  props: ["other_details", "template_details", "is_edit"],
  data() {
    return {
      date: null,
      rules: {
        mainRule: [v => !!v || messages.MAIN_DATE_ERROR],
        mainVenue: [v => !!v || messages.MAIN_VENUE_ERROR]
      }
    };
  }
};
</script>
